export default __webpack_public_path__ + "static/media/mod06.aacbb75c.svg";